export enum RequirementStatus {
    active = 'Active',
    on_hold = 'On Hold',
    purchase_completed = 'Purchase Completed',
    lease_completed = 'Lease Completed',
    dead = 'Dead',
};
